import CountUp from "react-countup";
import SmittedePlotMini from "./SmittedePlotMini";

const easeDuration = 2; // seconds

function Smittede({ smittede }) {
	const smittedeSenest = smittede.sort((a, b) => b.date - a.date)[0]

	return (
		<div>
			<h1>Nye smittede</h1>
			<div className="numberCircle" style={{ fontSize:"70px", backgroundColor: "#87ab08", transition: `background-color ${easeDuration}s ease-out` }}>
				<CountUp end={smittedeSenest.newCases} decimals={0} duration={easeDuration} />
				<div className="circleDate">
					<small>{smittedeSenest.date.toISOString().substring(0, 10)}</small>
				</div>
			</div>
			<SmittedePlotMini smittede={smittede} />
		</div>
	)
}

export default Smittede